import type { Scalars, TextModelTextBlocksField } from 'datocms/models'
import { type Component } from 'svelte'

export type StructuredTextType<T = TextModelTextBlocksField> = {
	blocks?: Array<T>
	links: Array<Scalars['String']['output']>
	value: Scalars['JsonField']['output']
}

export type BlockComponent = {
	__typename: string
	component: Component
}

export function isStructuredTextEmpty(item: StructuredTextType<unknown>) {
	return (
		(!item.blocks || item.blocks?.length === 0) &&
		item.value?.document?.children[0]?.children[0]?.value === ''
	)
}
